export const FEEDBACK_STAR_THRESHOLD = 3;
export const SEMAFORO = {
  RED_MAX:    60,
  YELLOW_MAX: 80,
};

// Umbrales del semáforo del portal del director (sobre porcentaje 0-100).
export const DIRECTOR_SEMAFORO = {
  GREEN_MIN:  70,
  YELLOW_MIN: 40,
};

// Cómo se visualiza la calificación en el portal del director.
// Configurable por campamento: Camp.directorScoreDisplay
export const SCORE_DISPLAY = {
  SEMAFORO:   'semaforo',
  PUNTUACION: 'puntuacion',
  AMBOS:      'ambos',
};

// Formato del número cuando el modo muestra puntuación.
// Configurable por campamento: Camp.directorScoreFormat
export const SCORE_FORMAT = {
  PORCENTAJE: 'porcentaje',
  PUNTOS:     'puntos',
};

export const SCORE_DISPLAY_OPTIONS = [
  { value: SCORE_DISPLAY.SEMAFORO,   label: 'Semáforo (colores)' },
  { value: SCORE_DISPLAY.PUNTUACION, label: 'Puntuación (números)' },
  { value: SCORE_DISPLAY.AMBOS,      label: 'Ambos (número sobre color)' },
];

export const SCORE_FORMAT_OPTIONS = [
  { value: SCORE_FORMAT.PORCENTAJE, label: 'Porcentaje (91%)' },
  { value: SCORE_FORMAT.PUNTOS,     label: 'Puntos (68/75)' },
];
